import React, { memo } from 'react';
import { prop } from 'ramda';
import { clsb, clsx } from 'js/utils/classNames.util';

import * as Types from '../../types';
import { useDynamicReducerSelector } from '../../store';

import style from './CarouselNumeration.scss';

export const CarouselNumerationBare: React.FC<Types.ICarouselNumerationProps> = ({ classNames, numerationIndex }) => {
    const { fontSize, width } = useDynamicReducerSelector(prop('numerationData'));
    const digits = numerationIndex.toString().split('');

    return (
        <svg
            viewBox={`0 0 ${width} ${fontSize}`} xmlns="http://www.w3.org/2000/svg"
            style={{ width: `${width}px` }}
            className={clsx([
                clsb([style, classNames], ['numerationContainer']),
                'cms-carousel-numeration-container',
                digits.length > 1 ? clsb([style, classNames], ['numerationComplex']) : '',
                digits.length > 1 ? 'cms-carousel-numeration-complex' : ''
            ])}
        >
            {digits.map((digit, index) => (
                <g
                    key={`${numerationIndex}_${index}`}
                    className={clsx([clsb([style, classNames], ['numeration']), 'cms-carousel-numeration'])}
                >
                    <text
                        x="0%"
                        y="100%"
                        style={{ fontSize: `${fontSize}px` }}
                    >
                        {digit}
                    </text>
                </g>
            ))}
        </svg>
    );
};

export const CarouselNumeration = memo(CarouselNumerationBare);
